module.exports = __webpack_public_path__ + "static/media/haunting.ecedf8b2.svg";